import styled from 'styled-components';
import {
  body2,
  borderRadius,
  caption,
  colors,
  fontSizes,
  fontWeights,
  heading1,
  heading4,
  letterSpacing,
  smallShadow,
  spacing,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Select } from 'ui/selectv2/Select';
import { ExitRuleClickToCopy } from 'modules/journey/components/RuleBuilder/RuleBlock/ExitRuleClickToCopy';

export const SliderHeader = styled.div`
  ${heading4}
  color: ${colors.textPrimary};
`;

export const ExitRuleSlideOverContainer = styled.div`
  display: flex;
  padding: 0 0 ${spacing.double} 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.plusHalf};
  align-self: stretch;
`;

export const RuleAggregateCard = styled.div`
  display: flex;
  padding: ${spacing.plusHalf};
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};

  border-radius: ${borderRadius.xl};
  background: ${colors.backgroundPrimary};

  ${smallShadow};
`;

export const RuleAggregateHeader = styled.div`
  ${body2}
  color: ${colors.secondaryText};
  font-weight: ${fontWeights.medium};
`;

export const RuleAggregateCount = styled.div`
  ${heading1}
  color: ${colors.textPrimary};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'dlig' on;
  font-weight: ${fontWeights.bold};
`;

export const RuleCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.plusHalf};
  align-self: stretch;
`;

export const RuleCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  align-self: stretch;
`;

export const RuleCard = styled.div`
  display: flex;
  padding: ${spacing.plusHalf};
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.base};
  align-self: stretch;

  border-radius: ${borderRadius.xl};
  background: ${colors.backgroundPrimary};

  ${smallShadow}
`;

export const RuleCardHeaderWrapper = styled.div`
  display: flex;
  padding-bottom: ${spacing.plusHalf};
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  align-self: stretch;
  border-bottom: ${spacing.single} solid ${colors.borderPrimary};
`;

export const RuleCardHeader = styled.div`
  ${body2};
  color: ${colors.secondaryText} !important;
`;

export const RuleCardCount = styled.div`
  color: ${colors.textPrimary};
  font-variant-numeric: lining-nums tabular-nums;

  font-size: ${fontSizes.s24};
  font-weight: ${fontWeights.bold};
  line-height: ${fontSizes.s28};
  letter-spacing: ${letterSpacing.neg25};
`;

export const RuleCardCriteriaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.quarter};
  align-self: stretch;
`;

export const RuleCriteriaText = styled.div`
  ${body2};
  display: flex;
  gap: ${pxToRem(3)};
  align-items: baseline;
  color: ${colors.textSecondary};
`;

export const RuleCriteriaValue = styled.div`
  color: ${colors.textPrimary};
  /* mono/caption/700 */
  ${caption};
  font-family: Menlo, Monaco, Consolas, 'Lucida Console', monospace;
  font-size: ${fontSizes.s11};
  font-style: normal;
  font-weight: ${fontWeights.bold};
  letter-spacing: ${letterSpacing.neg25};
`;

export const RuleCardCriteriaEvent = styled.div`
  ${body2};
  color: ${colors.textPrimary};
  font-weight: ${fontWeights.medium};
`;

export const SearchQueryCriteriaCardContainer = styled.div`
  display: flex;
  gap: ${pxToRem(5)};
`;

export const SetOn = styled.div`
  ${caption};
  color: ${colors.secondaryText};
  font-weight: ${fontWeights.regular};
`;

/* Select */

export const TileExitSelect = styled(Select)`
  width: 100%;
`;
export const TileOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

export const TileTitle = styled.div`
  align-self: stretch;
  overflow: hidden;
  color: ${colors.textPrimary};
  text-overflow: ellipsis;
  ${body2}
`;

export const TileId = styled.div`
  align-self: stretch;
  overflow: hidden;
  color: ${colors.textSecondary};
  text-overflow: ellipsis;
  ${caption}
`;

export const TileExitContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const TileExit = styled.div`
  display: flex;
  color: ${colors.textSecondary};
  text-align: right;
  ${body2}
`;

export const TileExitCount = styled.div`
  color: ${colors.textPrimary};
  ${body2}
`;

export const StyledExitRuleClickToCopy = styled(ExitRuleClickToCopy)`
  align-self: stretch;
`;
